"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUnclaimedSupplyResponseToJSON = exports.GetUnclaimedSupplyResponseFromJSONTyped = exports.GetUnclaimedSupplyResponseFromJSON = void 0;
function GetUnclaimedSupplyResponseFromJSON(json) {
    return GetUnclaimedSupplyResponseFromJSONTyped(json, false);
}
exports.GetUnclaimedSupplyResponseFromJSON = GetUnclaimedSupplyResponseFromJSON;
function GetUnclaimedSupplyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': json['amount'],
    };
}
exports.GetUnclaimedSupplyResponseFromJSONTyped = GetUnclaimedSupplyResponseFromJSONTyped;
function GetUnclaimedSupplyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': value.amount,
    };
}
exports.GetUnclaimedSupplyResponseToJSON = GetUnclaimedSupplyResponseToJSON;
